kdx-comparison-card { 
    height: 100%; 

    kdx-card { 
        height: 100%; 

        &.hydrated { height: 100%; }
    }
}
.kdx-card.kdx-comparison-card {    
    margin: 10px 0;
    padding: 20px 30px;
    @include text-size(13);
    box-shadow: 0 5px 18px rgba(0, 0, 0, .12);
    border: none;
    border-radius: 2px;
/*    background: #FFF;*/
    @include text-size(14);
    @include line-height(22);

    p {
        margin-bottom: 18px;
        text-align: center;
    }

    .card-title {
        color: $compareCard_heading;
        position: relative;
        text-align: center;
        @include text-size(21);
        @include line-height(24);
        padding-bottom: 8px;
        margin: 0 0 24px 0;

        &::after {
            content: '';
            width: 100%;
            max-width: 65px;
            height: 3px;
            background: $compareCard_headingBorder;
            position: absolute;
            top: 100%;
            left: 50%;
            transform: translateX(-50%);
        }
    }

    .sub-layer{
        margin: 30px 0px;
        padding: 0px 30px;

        h3{
            text-align: left;
            border-bottom: solid 1px $quarternary;
            margin: 0px -30px 20px;
            padding: 0 5px 10px;
            @include text-size(16);
        }

        ul {

            height: fit-content;
            li {
                list-style: none;
                padding: 0 0 20px 0 !important;

                &:before {
                    left: -25px !important;
                }
            }
        }
    }

    .product-content {
        ul {
            padding: 0 0 0 30px;
            margin: 0;
            text-align: left;

            li {
                position: relative;
                list-style: disc;
                padding: 0 0 20px 4px;

                &::before {
                    top: 2px;
                    left: 0;
                }
            }
        }
    }

    .card-body {
        padding: 0;
    }

    .card-footer {
        text-align: center;
        background: none;
        border: none;
        padding: $gutter-def 0 0;

        &.ctas {
            display: flex;
            flex-direction: column;
            min-height: 1px;
            height: auto;
            align-items: center;

            a {
                margin-bottom: 16px;
                
                &.btn { width: 100%; }
                &:last-child { margin-bottom: 0; }
            }
        }        
    }     
}



@include media-breakpoint-down(lg) {
    .kdx-card.kdx-comparison-card { margin: 0 10px; }    
}
